<div class="container" fxLayout="row" >
      <div class="breadcrumb">
        <p>
          <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
          <span>Alerts</span> 
        </p>
      </div> 
  <div fxLayout="row" fxLayoutGap="50"  fxFlex="100">
      <div fxFlex="50" class="alerts-consent" fxLayout="column">
            <div fxLayout="row" class="alerts-heading">
                  <div class="mat-card-title" [ngClass]="{ 'create-consent-heading': currentStep === 'createConsent' }"> Create User Consent</div>
                  <div class="mat-card-title" [ngClass]="{ 'user-type-heading': currentStep === 'userType' }">User Type</div>
                  <div class="mat-card-title" [ngClass]="{ 'footer-heading': currentStep === 'footer' }">Footer</div>
              </div>
            <mat-card>
              <div *ngIf="currentStep === 'createConsent'" class="consent-div"> 
                <div fxLayout="row wrap" fxLayoutGap="30">
                      <mat-card-header class="mat-card-heading">Communication Type:</mat-card-header>
                        <mat-radio-group [(ngModel)]="selectedCommunicationType">
                          <div class="row">
                            <mat-radio-button value="api">API</mat-radio-button> 
                            <!-- <mat-radio-button value="push">Push Notification</mat-radio-button> -->
                          </div>
                          <!-- <mat-radio-button  value="silentpush">Silent Push Notification</mat-radio-button>  -->
                        </mat-radio-group>
                    </div>
                        <div fxLayout="row">
                          <mat-card-header class="mat-card-heading">Header:</mat-card-header>
                                <mat-form-field appearance="outline" class="mat-form-field custom-placeholder" fxFlex="100%">
                                    <input matInput [(ngModel)]="enteredHeader" [placeholder]="headerPlaceholder" autocomplete="on" required #headerInput="ngModel">
                                    <mat-error *ngIf="headerInput.invalid && (headerInput.dirty || headerInput.touched)">
                                      Header is required
                                    </mat-error>
                                  </mat-form-field>
                          </div>
                                <div fxLayout="row wrap" >
                                      <mat-card-header class="mat-card-heading">Content:</mat-card-header>
                                          <mat-radio-group class="row" [(ngModel)]="selectedConsentType">
                                            <mat-radio-button id="Dynamic" value="dynamic">Dynamic (Paste the HTML URL here)</mat-radio-button>
                                            <mat-radio-button id="Static" value="static">Static (Enter text Manually)</mat-radio-button>
                                          </mat-radio-group>

                                          <mat-form-field appearance="outline" class="mat-form-field custom-placeholder" fxFlex="100%">
                                            <textarea [(ngModel)]="HTMLContent" name="content" matInput [placeholder]="contentPlaceholder" required #contentInput="ngModel"></textarea>
                                            <mat-error *ngIf="contentInput.invalid && (contentInput.dirty || contentInput.touched)">
                                              Content is required
                                            </mat-error>
                                          </mat-form-field>
                                          <span *ngIf="dynamicContentError" class="error-message" style="color: red;">{{ dynamicContentError }}</span> 
                                          
                                    </div>
                
                                <div class="mat-button-div">
                                  <button class="mat-button-prev" mat-raised-button (click)="resetCreateConsent()">Reset</button>
                                  <button class="mat-button-next" mat-raised-button (click)="moveToNextStep('userType')">Next</button>
                                </div>
            </div>
            </mat-card>
              
            <mat-card>
              <div *ngIf="currentStep === 'userType'" class="type-div">
                <div fxLayout="column"  fxLayoutGap="30">
                      <div fxLayout="row wrap">
                            <mat-card-header class="mat-card-heading">Type:</mat-card-header>
                                <mat-radio-group [(ngModel)]="userType">
                                  <mat-radio-button value="action">Action</mat-radio-button>
                              </mat-radio-group>
                            <!-- <mat-form-field appearance="outline" class="mat-form-field">
                              <mat-label>Action</mat-label>
                                <mat-select [(ngModel)]="userType" >
                                    <mat-option value="action">Action</mat-option>
                                    <mat-option value="information">Information</mat-option>
                                    <mat-option value="navigate">Navigate</mat-option>
                                  </mat-select>
                              </mat-form-field> -->

                              <div fxFlex="20"></div> 
                              
                            <mat-card-header class="mat-card-heading">Value:</mat-card-header>
                              <mat-form-field appearance="outline" class="mat-form-field">
                                  <mat-label>Accept</mat-label>
                                    <mat-select [(ngModel)]="userValue">
                                        <mat-option value="accept">Accept</mat-option>
                                        <mat-option value="deny">Deny</mat-option>
                                      </mat-select>
                                </mat-form-field>

                        </div>
                           
                        <div fxLayout="column">
                                <div fxLayout="row wrap">
                                      <mat-card-header class="mat-card-heading">Display Name:</mat-card-header>
                                      <mat-form-field appearance="outline" class="mat-form-field custom-placeholder" fxFlex="100%">
                                          <input matInput [(ngModel)]="displayName" [placeholder]="displayPlaceholder" autocomplete="on" required #displayInput="ngModel">
                                          <mat-error *ngIf="displayInput.invalid && (displayInput.dirty || displayInput.touched)">
                                            Display name is required
                                          </mat-error>
                                      </mat-form-field>
                              
                                      <div fxLayout="row wrap" fxFlex="100">
                                        <div fxLayoutAlign="start center" fxFlex.gt-sm="70" fxFlex="100">
                                            <mat-card-header class="mat-card-heading">Allow using App?</mat-card-header>
                                            <mat-radio-group [(ngModel)]="action.allowApp" (ngModelChange)="onAllowAppChange($event)">
                                                <mat-radio-button id="Yes" value="yes">Yes</mat-radio-button>
                                                <mat-radio-button id="No" value="no">No</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                
                                        <div fxLayoutAlign="end center" fxFlex.gt-sm="30">
                                            <button class="action-button" color="primary" mat-stroked-button (click)="addAction()">Add Action</button>
                                        </div>
                                    </div>
                              </div>
                        
                                  <div class="user-mat-button-div">
                                        <button class="mat-button-prev" mat-raised-button (click)="resetUserType()">Reset</button>
                                        <button class="mat-button-prev" mat-raised-button (click)="moveToPrevStep('createConsent')">Back</button>
                                        <button class="mat-button-next" mat-raised-button (click)="moveToNextStep('footer')">Next</button>
                                    </div>
                          </div>
                    </div>
              </div> 
            </mat-card> 
              
              <mat-card>
                <div class="footer-div" *ngIf="currentStep === 'footer'">
                  <div fxLayout="column" class="table-container">
                        <mat-card-header class="mat-card-heading">Action Created:</mat-card-header>
                          <div fxLayout="row wrap" class="header">
                                <div class="cell">Display Name</div>
                                <div class="cell">Type</div>
                                <div class="cell">Value</div>
                                <div class="cell">Allow App</div>
                                <div class="cell"></div>
                            </div>
                          <div *ngIf="showTable">
                            <div *ngFor="let action of addedActions; let i = index" fxLayout="row">
                                <div class="cell">{{ action.displayName }}</div>
                                <div class="cell">{{ action.userType }}</div>
                                <div class="cell">{{ action.userValue }}</div>
                                <div class="cell">{{ action.allowApp }}</div>
                                <div class="delete" (click)="removeAction(i)">X</div>
                            </div>
                          </div>
                    </div>
                        <div fxLayout="row wrap">
                          <mat-card-header class="mat-card-heading">Footer:</mat-card-header>
                              <mat-form-field appearance="outline" class="mat-form-field custom-placeholder" fxFlex="100%">
                                <input matInput [(ngModel)]="FooterText" [placeholder]="footerPlaceholder" autocomplete="on" required #footerInput="ngModel" name="footer">
                                <mat-error *ngIf="footerInput.invalid && (footerInput.dirty || footerInput.touched)">
                                  Footer is required
                                </mat-error>
                              </mat-form-field>
                        </div>
                
                        <div class="mat-button-div">
                              <button class="mat-button-prev" mat-raised-button (click)="resetFooter()">Reset</button>
                              <button class="mat-button-prev" mat-raised-button (click)="moveToPrevStep('userType')">Back</button>
                               <button class="mat-button-next" mat-stroked-button color="primary" (click)="postDataToServer();">Create</button>
                          </div>
                  </div>
              </mat-card>
        
      </div>

      <mat-card>
        <div fxFlex="40" class="alert-preview-content">
          <div fxFlex="100" fxLayout="column" fxLayoutGap="15">
            <mat-card-header fxLayoutAlign="center" class="alert-preview-heading">Alert Preview</mat-card-header>
            <div class="mat-card-heading">Header:</div>
            <div class="preview-content">{{ enteredHeader }}</div>
            <div class="mat-card-heading">Content:</div>
            <div class="preview-content">{{ HTMLContent }}</div>
            <div class="mat-card-heading">Action: </div>
            <div class="preview-content" *ngFor="let action of addedActions">Type: {{ action.userType }} - Value: {{ action.userValue }} - Allow App: {{ action.allowApp }} - Display Name:{{ action.displayName }} </div>
            <div class="footer-title">Footer: </div>
            <div class="preview-content">{{ FooterText }}</div>
          </div>
        </div>
      </mat-card>
    </div>
</div>

<div class="consent-table">
  <div class="all-consents-container" fxFlex="100">
        <table>
          <thead>
            <tr class="mat-card-title">
              <th>Header</th>
              <th>Content</th>
              <th>User Actions</th>
              <th>Footer</th>
              <th>Created By</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr class="preview-content" *ngFor="let consent of getDisplayedConsents(); let i=index">
              <td>{{ consent.data.header }}</td>
              <td>{{ consent.data.content }}</td>
              <td><span *ngFor="let action of consent.data.useractions" class="ng-binding ng-scope">{{ action.name }}   </span></td>
              <td>{{ consent.data.footer }}</td>
              <td>
                <div fxLayout="column">
                  <span>{{ consent.agentName }}</span>
                  <span>{{ consent.created }}</span>
                </div>
              </td>
              <td>{{ consent.notified ? 'Released' : 'In Review' }}</td> 
              <td>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="releaseConsent(consent.id, consent.communicationType, consent.data.header, consent.data.contenttype, consent.data.content, action.name, consent.data.footer, consent.created, consent.notified); consent.notified = true;">Release</button>
                  <button mat-menu-item (click)="openTestDialog(consent)">Test</button>
                  <button mat-menu-item (click)="deleteConsentData(consent.id,i); toggleRender();">Delete</button>
              </mat-menu>
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>...</mat-icon>
                </button>
              </td>  
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="pagination-controls" >
      <div class="pagination">
        <button class="mat-button-prev" mat-raised-button (click)="prevPage()" [disabled]="currentPage === 1">Previous</button>
      <span class="page-button">Page {{ currentPage }} of {{ totalPages }}</span>
      <button class="mat-button-prev" mat-raised-button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
      </div>

      <div class="items">
        <mat-form-field appearance="outline">
          <mat-select [placeholder]="defaultPlaceholder" [(value)]="pageSize" (selectionChange)="onPageSizeChange($event)">
            <mat-option value="5">5 items per page</mat-option>
            <mat-option value="10">10 items per page</mat-option>
            <mat-option value="15">15 items per page</mat-option>
            <mat-option value="20">20 items per page</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>